import script from "./MdmToolsCollectionEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./MdmToolsCollectionEditor.vue?vue&type=script&setup=true&lang=js"

import "./MdmToolsCollectionEditor.vue?vue&type=style&index=0&id=1c2b177f&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ELA/ELA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c2b177f"]])

export default __exports__